import _ from 'lodash';
import createCachedSelector from 're-reselect';
import { getPredictor } from '../getPredictor';

export const getInputs = createCachedSelector(
  [getPredictor],
  predictor => _.chain(predictor).get('inputMappings').map('input').value()
)(
  (state, chartType) => chartType
);